'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = require('../../lib/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Default__hiddenInput___3fGAk',
  'container': 'Default__container___2viz_',
  'checkboxUnchecked': 'Default__checkboxUnchecked___2TvQ-',
  'checkbox': 'Default__checkbox___2gFBy',
  'checkboxChecked': 'Default__checkboxChecked___3pdpQ',
  'checkmark': 'Default__checkmark___ApF0J',
  'label': 'Default__label___2_a4i'
};

var DefaultCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
DefaultCheckbox.displayName = 'DefaultCheckbox';
exports.default = DefaultCheckbox;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Checkbox/index.js
// module id = 846
// module chunks = 4 5 8 9 14